import React from "react";

export default function MSAccess_Hour() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Hour</h1>
      <p>This is the MSAccess_Hour component generated from the SQL JSON.</p>
    </div>
  );
}
